import React, { useEffect, useState } from 'react';
import userService from '../../services/userService';
import { getApiErrorMessage } from '../../utils/errorMessages';

const emptyForm = { full_name: '', email: '', phone: '', cpf: '', password: '', role: 'doctor' };

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const loadUsers = async () => setUsers(await userService.list());

  useEffect(() => {
    loadUsers().catch((requestError) => setError(getApiErrorMessage(requestError, 'Não foi possível carregar os usuários.')));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage('');
    setError('');
    setSaving(true);
    try {
      await userService.create(form);
      setForm(emptyForm);
      setMessage('Usuário criado. Para médicos, complete o CRM na área Médicos da recepção.');
      await loadUsers();
    } catch (requestError) {
      setError(getApiErrorMessage(requestError, 'Não foi possível criar o usuário.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dashboard-section">
      <h2>Administração</h2>
      {error && <div className="alert alert-error">{error}</div>}
      {message && <div className="alert alert-success">{message}</div>}
      <form className="appointment-form" onSubmit={handleSubmit}>
        <fieldset className="form-section-card">
          <legend>Criar acesso da equipe</legend>
          <div className="form-section-grid">
            <label>Nome completo<input value={form.full_name} onChange={(event) => setForm({ ...form, full_name: event.target.value })} required /></label>
            <label>E-mail<input type="email" value={form.email} onChange={(event) => setForm({ ...form, email: event.target.value })} required /></label>
            <label>CPF<input value={form.cpf} onChange={(event) => setForm({ ...form, cpf: event.target.value })} minLength="11" required /></label>
            <label>Telefone<input value={form.phone} onChange={(event) => setForm({ ...form, phone: event.target.value })} /></label>
            <label>Perfil<select value={form.role} onChange={(event) => setForm({ ...form, role: event.target.value })}><option value="doctor">Médico</option><option value="reception">Recepção</option></select></label>
            <label>Senha inicial<input type="password" value={form.password} onChange={(event) => setForm({ ...form, password: event.target.value })} minLength="8" required /></label>
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Salvando...' : 'Criar acesso'}</button>
        </fieldset>
      </form>
      <div className="dashboard-section">
        <h3>Usuários cadastrados</h3>
        <div className="table-wrapper">
          <table><thead><tr><th>Nome</th><th>E-mail</th><th>Perfil</th><th>Status</th></tr></thead>
            <tbody>{users.map((user) => <tr key={user.id}><td>{user.full_name}</td><td>{user.email}</td><td>{user.role}</td><td>{user.status}</td></tr>)}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
